import { RootState } from '../../store/rootReducer';

export const LandingPageTeaserContentSelector = (state: RootState) => state.content.landingPageTeaser;
